// extracted by mini-css-extract-plugin
export default {"card-overlay":"components-hotel-benchmark-insight-card-overlay-module__card-overlay"};